import { render, staticRenderFns } from "./BulkImport.vue?vue&type=template&id=0bb1ffee&scoped=true&"
import script from "./BulkImport.vue?vue&type=script&lang=js&"
export * from "./BulkImport.vue?vue&type=script&lang=js&"
import style0 from "./BulkImport.vue?vue&type=style&index=0&id=0bb1ffee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb1ffee",
  null
  
)

export default component.exports